/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateRewardConfigRequestBody,
    CreateRewardConfigRequestBodyFromJSON,
    CreateRewardConfigRequestBodyToJSON,
    DistributeRewardRequest,
    DistributeRewardRequestFromJSON,
    DistributeRewardRequestToJSON,
    DistributedRewardResponse,
    DistributedRewardResponseFromJSON,
    DistributedRewardResponseToJSON,
    GetDistributedRewardsOwnResponse,
    GetDistributedRewardsOwnResponseFromJSON,
    GetDistributedRewardsOwnResponseToJSON,
    GetRewardConfigsResponse,
    GetRewardConfigsResponseFromJSON,
    GetRewardConfigsResponseToJSON,
    ManualDistributeRewardResponse,
    ManualDistributeRewardResponseFromJSON,
    ManualDistributeRewardResponseToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseToJSON,
    UpdateRewardConfigRequestBody,
    UpdateRewardConfigRequestBodyFromJSON,
    UpdateRewardConfigRequestBodyToJSON,
} from '../models';

export interface CreateRewardConfigRequest {
    createRewardConfigRequestBody?: CreateRewardConfigRequestBody;
}

export interface DismissNotificationDevourPlayRequest {
    id: string;
}

export interface DismissNotificationWebRequest {
    id: string;
}

export interface DistributeRewardConfigRequest {
    distributeRewardRequest?: DistributeRewardRequest;
}

export interface GetDistributedRewardSingleRequest {
    id: string;
}

export interface GetDistributedRewardsOwnRequest {
    subject?: string;
    webNotificationDismissed?: boolean;
    devourPlayNotificationDismissed?: boolean;
}

export interface GetRewardConfigsRequest {
    search?: string;
    ids?: Array<string>;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface UpdateRewardConfigRequest {
    id: string;
    updateRewardConfigRequestBody?: UpdateRewardConfigRequestBody;
}

/**
 * RewardsApi - interface
 * @export
 * @interface RewardsApiInterface
 */
export interface RewardsApiInterface {
    /**
     * Used to create new Overwolf quest (OWReward doc)
     * @param {CreateRewardConfigRequestBody} [createRewardConfigRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    createRewardConfigRaw(requestParameters: CreateRewardConfigRequest): Promise<runtime.ApiResponse<RewardConfigResponse>>;

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    createRewardConfig(requestParameters: CreateRewardConfigRequest): Promise<RewardConfigResponse>;

    /**
     * Used to dismiss a distributed reward notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    dismissNotificationDevourPlayRaw(requestParameters: DismissNotificationDevourPlayRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to dismiss a distributed reward notification
     */
    dismissNotificationDevourPlay(requestParameters: DismissNotificationDevourPlayRequest): Promise<void>;

    /**
     * Used to dismiss a distributed reward notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    dismissNotificationWebRaw(requestParameters: DismissNotificationWebRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to dismiss a distributed reward notification
     */
    dismissNotificationWeb(requestParameters: DismissNotificationWebRequest): Promise<void>;

    /**
     * Used by admins to manually distribute rewards
     * @param {DistributeRewardRequest} [distributeRewardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    distributeRewardConfigRaw(requestParameters: DistributeRewardConfigRequest): Promise<runtime.ApiResponse<ManualDistributeRewardResponse>>;

    /**
     * Used by admins to manually distribute rewards
     */
    distributeRewardConfig(requestParameters: DistributeRewardConfigRequest): Promise<ManualDistributeRewardResponse>;

    /**
     * Retrieves a single distributed reward data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    getDistributedRewardSingleRaw(requestParameters: GetDistributedRewardSingleRequest): Promise<runtime.ApiResponse<DistributedRewardResponse>>;

    /**
     * Retrieves a single distributed reward data.
     */
    getDistributedRewardSingle(requestParameters: GetDistributedRewardSingleRequest): Promise<DistributedRewardResponse>;

    /**
     * Used by user to get a list of all their distributed rewards
     * @param {string} [subject] 
     * @param {boolean} [webNotificationDismissed] 
     * @param {boolean} [devourPlayNotificationDismissed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    getDistributedRewardsOwnRaw(requestParameters: GetDistributedRewardsOwnRequest): Promise<runtime.ApiResponse<GetDistributedRewardsOwnResponse>>;

    /**
     * Used by user to get a list of all their distributed rewards
     */
    getDistributedRewardsOwn(requestParameters: GetDistributedRewardsOwnRequest): Promise<GetDistributedRewardsOwnResponse>;

    /**
     * Used by admin to get a list of all reward configs
     * @param {string} [search] 
     * @param {Array<string>} [ids] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    getRewardConfigsRaw(requestParameters: GetRewardConfigsRequest): Promise<runtime.ApiResponse<GetRewardConfigsResponse>>;

    /**
     * Used by admin to get a list of all reward configs
     */
    getRewardConfigs(requestParameters: GetRewardConfigsRequest): Promise<GetRewardConfigsResponse>;

    /**
     * Used to update existing Overwolf game
     * @param {string} id 
     * @param {UpdateRewardConfigRequestBody} [updateRewardConfigRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    updateRewardConfigRaw(requestParameters: UpdateRewardConfigRequest): Promise<runtime.ApiResponse<RewardConfigResponse>>;

    /**
     * Used to update existing Overwolf game
     */
    updateRewardConfig(requestParameters: UpdateRewardConfigRequest): Promise<RewardConfigResponse>;

}

/**
 * no description
 */
export class RewardsApi extends runtime.BaseAPI implements RewardsApiInterface {

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createRewardConfigRaw(requestParameters: CreateRewardConfigRequest): Promise<runtime.ApiResponse<RewardConfigResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rewards`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRewardConfigRequestBodyToJSON(requestParameters.createRewardConfigRequestBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardConfigResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createRewardConfig(requestParameters: CreateRewardConfigRequest): Promise<RewardConfigResponse> {
        const response = await this.createRewardConfigRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async dismissNotificationDevourPlayRaw(requestParameters: DismissNotificationDevourPlayRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling dismissNotificationDevourPlay.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/distributed-rewards/{id}/dismiss-notification-devour-play`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async dismissNotificationDevourPlay(requestParameters: DismissNotificationDevourPlayRequest): Promise<void> {
        await this.dismissNotificationDevourPlayRaw(requestParameters);
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async dismissNotificationWebRaw(requestParameters: DismissNotificationWebRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling dismissNotificationWeb.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/distributed-rewards/{id}/dismiss-notification-web`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async dismissNotificationWeb(requestParameters: DismissNotificationWebRequest): Promise<void> {
        await this.dismissNotificationWebRaw(requestParameters);
    }

    /**
     * Used by admins to manually distribute rewards
     */
    async distributeRewardConfigRaw(requestParameters: DistributeRewardConfigRequest): Promise<runtime.ApiResponse<ManualDistributeRewardResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rewards/distribute`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributeRewardRequestToJSON(requestParameters.distributeRewardRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ManualDistributeRewardResponseFromJSON(jsonValue));
    }

    /**
     * Used by admins to manually distribute rewards
     */
    async distributeRewardConfig(requestParameters: DistributeRewardConfigRequest): Promise<ManualDistributeRewardResponse> {
        const response = await this.distributeRewardConfigRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a single distributed reward data.
     */
    async getDistributedRewardSingleRaw(requestParameters: GetDistributedRewardSingleRequest): Promise<runtime.ApiResponse<DistributedRewardResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getDistributedRewardSingle.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/distributed-rewards/{id}/single`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributedRewardResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single distributed reward data.
     */
    async getDistributedRewardSingle(requestParameters: GetDistributedRewardSingleRequest): Promise<DistributedRewardResponse> {
        const response = await this.getDistributedRewardSingleRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by user to get a list of all their distributed rewards
     */
    async getDistributedRewardsOwnRaw(requestParameters: GetDistributedRewardsOwnRequest): Promise<runtime.ApiResponse<GetDistributedRewardsOwnResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.subject !== undefined) {
            queryParameters['subject'] = requestParameters.subject;
        }

        if (requestParameters.webNotificationDismissed !== undefined) {
            queryParameters['webNotificationDismissed'] = requestParameters.webNotificationDismissed;
        }

        if (requestParameters.devourPlayNotificationDismissed !== undefined) {
            queryParameters['devourPlayNotificationDismissed'] = requestParameters.devourPlayNotificationDismissed;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/distributed-rewards/own`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDistributedRewardsOwnResponseFromJSON(jsonValue));
    }

    /**
     * Used by user to get a list of all their distributed rewards
     */
    async getDistributedRewardsOwn(requestParameters: GetDistributedRewardsOwnRequest): Promise<GetDistributedRewardsOwnResponse> {
        const response = await this.getDistributedRewardsOwnRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by admin to get a list of all reward configs
     */
    async getRewardConfigsRaw(requestParameters: GetRewardConfigsRequest): Promise<runtime.ApiResponse<GetRewardConfigsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Optional", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reward-configs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRewardConfigsResponseFromJSON(jsonValue));
    }

    /**
     * Used by admin to get a list of all reward configs
     */
    async getRewardConfigs(requestParameters: GetRewardConfigsRequest): Promise<GetRewardConfigsResponse> {
        const response = await this.getRewardConfigsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateRewardConfigRaw(requestParameters: UpdateRewardConfigRequest): Promise<runtime.ApiResponse<RewardConfigResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRewardConfig.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rewards/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRewardConfigRequestBodyToJSON(requestParameters.updateRewardConfigRequestBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardConfigResponseFromJSON(jsonValue));
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateRewardConfig(requestParameters: UpdateRewardConfigRequest): Promise<RewardConfigResponse> {
        const response = await this.updateRewardConfigRaw(requestParameters);
        return await response.value();
    }

}
